import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=8f33312c&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/nsdua/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f33312c')) {
      api.createRecord('8f33312c', component.options)
    } else {
      api.reload('8f33312c', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=8f33312c&", function () {
      api.rerender('8f33312c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/component/avatar.vue"
export default component.exports